module.exports = __webpack_public_path__ + "static/img/chejia_advantage.3bcaaee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/VehicleInformation/chejia_advantage.png
// module id = MtMf
// module chunks = 19